module.exports = __webpack_public_path__ + "img/ic_sunrise_sunset.a9bdd9f1.png";